import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How does the AI scribe work during a patient encounter?",
    answer:
      "ConsultNow uses ambient AI to listen to the natural conversation between provider and patient. It automatically identifies clinical details, organizes them into your preferred note format (SOAP, H&P, or custom templates), and generates a complete draft note for your review within seconds of the encounter ending.",
  },
  {
    question: "Is ConsultNow HIPAA compliant?",
    answer:
      "Yes. ConsultNow is SOC 2 Type II certified with full HIPAA compliance. We provide a Business Associate Agreement (BAA) for all customers. All data is encrypted at rest and in transit, with role-based access controls and comprehensive audit logging.",
  },
  {
    question: "Which EHR systems does ConsultNow integrate with?",
    answer:
      "We integrate with Epic, Cerner, athenahealth, eClinicalWorks, Allscripts, NextGen, and 30+ other EHR systems. Notes sync directly into the patient chart via HL7 FHIR and proprietary connectors — no manual data entry required.",
  },
  {
    question: "How long does onboarding take for a practice?",
    answer:
      "Solo providers can be live in under 24 hours. Group practices typically take 1-2 weeks, which includes EHR integration setup, template customization, and staff training. Enterprise deployments are scoped individually based on network size and requirements.",
  },
  {
    question:
      "Can different providers on our team use different note templates?",
    answer:
      "Absolutely. Each provider can set their own specialty-specific templates and documentation preferences. Administrators can manage and set default templates centrally, while individual providers can override them at the personal level to match their workflow.",
  },
  {
    question: "What happens if the AI makes an error in a note?",
    answer:
      "Every note goes through provider review before it reaches the chart. The editing interface highlights AI-generated content, and providers can accept, modify, or regenerate any section. Accuracy rates typically exceed 95% and improve further as the system learns each provider's preferences.",
  },
];

export function Faq() {
  return (
    <section
      id="faq"
      className="py-20 lg:py-28 bg-gradient-to-b from-slate-50 to-white scroll-mt-16"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-sm font-semibold uppercase tracking-widest text-brand-red mb-3">
            FAQ
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-brand-navy mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-slate-500 leading-relaxed">
            Everything you need to know about ConsultNow.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`faq-${index}`}
                className="bg-white rounded-xl border border-slate-200 px-6 shadow-sm data-open:shadow-md transition-shadow"
              >
                <AccordionTrigger className="text-left text-base font-semibold text-brand-navy hover:text-brand-red py-5 hover:no-underline aria-expanded:text-brand-red">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-500 leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
